import React from 'react';

import { MDText } from 'i18n-react';

import { PriceTagIcon, TickChunkyIcon, VehicleFrontIcon } from '@motorway/mw-highway-code';

import { Content } from 'LegacySBCRA/Content/Content';

import { SimpleUsp } from '../../../../../storybook/components/local/SimpleUsp/SimpleUsp';
import { usePageRefEvents } from '../../Pages/CheckerRouter.utils';
import LocalTexts from '../../texts.json';

import styles from './CheckerUsp.scss';

const LocalT = new MDText(LocalTexts);

const translate = (key: string) => LocalT.translate(key) as string;
const getTexts = (checkerType: string) => [1, 2, 3].map((i) => ({ text: translate(`usp.${checkerType}.text${i}`), title: translate(`usp.${checkerType}.title${i}`) }));

type CheckerUspProps = {
  isMotCheck: boolean;
  onLoad: () => void;
}

const icons = [TickChunkyIcon, PriceTagIcon, VehicleFrontIcon];

export const CheckerUsp = ({ isMotCheck, onLoad }: CheckerUspProps) => {
  const { setRef } = usePageRefEvents({ onRefTrigger: onLoad });

  return (
    <Content className={styles.uspWrapper}>
      <div ref={(ref) => setRef(ref)} className={styles.component} data-testid='checker-usp'>
        {getTexts(isMotCheck ? 'mot' : 'tax').map(({ text, title }, i) => <SimpleUsp key={title} {...{ icon: icons[i], text, title }} />)}
      </div>
    </Content>
  );
};
